import React from 'react';
import {
  Typography,
} from '@mui/material';

function EncounterNotes({ noteText, forwardRef }) {
  return (
    <>
      <div ref={forwardRef} style={{ paddingInline: '8px' }}>
        <Typography><span dangerouslySetInnerHTML={{ __html: noteText }} /></Typography>
      </div>
    </>
  );
}

export { EncounterNotes };
